import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Renders any ISO-style date (`YYYY-MM-DD`, `YYYY-MM-DDTHH:MM:SSZ`, or a
 * JS `Date`) using an AMC-configurable format token. Keeps invalid /
 * empty inputs untouched. Never triggers a locale round-trip (avoids TZ
 * shifts on pure calendar dates).
 *
 * Supported format tokens:
 *   • `DD-MMMM-YYYY` (default)  →  `17-June-2026`
 *   • `DD/MM/YYYY`              →  `17/06/2026`
 *   • `MMM DD, YYYY`            →  `Jun 17, 2026`
 *   • `YYYY-MM-DD`              →  `2026-06-17` (pass-through)
 */
const MONTHS = ["January","February","March","April","May","June","July","August","September","October","November","December"];
const MONTHS_SHORT = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
export const DATE_FORMAT_OPTIONS = [
  { value: "DD-MMMM-YYYY", label: "DD-Month-YYYY (17-June-2026)" },
  { value: "DD/MM/YYYY",   label: "DD/MM/YYYY (17/06/2026)" },
  { value: "MMM DD, YYYY", label: "Mon DD, YYYY (Jun 17, 2026)" },
  { value: "YYYY-MM-DD",   label: "YYYY-MM-DD (2026-06-17)" },
];
export function formatDate(value, format = "DD-MMMM-YYYY") {
  if (value == null || value === "") return value;
  let y, m, d;
  if (value instanceof Date) {
    y = value.getFullYear(); m = value.getMonth() + 1; d = value.getDate();
  } else {
    const match = String(value).trim().match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!match) return value;
    y = Number(match[1]); m = Number(match[2]); d = Number(match[3]);
  }
  if (!y || !m || !d || m < 1 || m > 12) return value;
  const dd = String(d).padStart(2, "0");
  const mm = String(m).padStart(2, "0");
  switch (format) {
    case "DD/MM/YYYY":   return `${dd}/${mm}/${y}`;
    case "MMM DD, YYYY": return `${MONTHS_SHORT[m - 1]} ${dd}, ${y}`;
    case "YYYY-MM-DD":   return `${y}-${mm}-${dd}`;
    case "DD-MMMM-YYYY":
    default:             return `${dd}-${MONTHS[m - 1]}-${y}`;
  }
}
